import { HeaderSection } from "./HeaderSection"
import { InformationSection } from "./InformationSection"
import { MiniCompanyProfile_company } from "__generated__/MiniCompanyProfile_company"

const MiniCompanyProfile = ({
    company,
}: {
    company: MiniCompanyProfile_company
}) => {
    return (
        <>
            <HeaderSection company={company} />
            <InformationSection company={company} />
        </>
    )
}

export { MiniCompanyProfile }
